// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-up.js';

import { paths } from '../generated/file-up';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-up', Original, paths);
